
import {
  Vue, Component, PropSync, Prop,
} from 'vue-property-decorator';
import CountrySelect from '@/features/common/components/CountrySelect.vue';
import InputPostalCode from '@/features/common/components/InputPostalCode.vue';
import { VForm } from '@/features/common/types';
import { CutoffTimesFormData } from '@/features/cutoff-times/views/CutoffTimes.vue';
import { requiredRules } from '@/features/common/helpers/validationRules';

@Component({
  components: {
    CountrySelect,
    InputPostalCode,
  },
})
export default class CutoffForm extends Vue {
  @Prop({ default: false }) isLoading!: boolean;

  @PropSync('data', { required: true }) syncedData!: CutoffTimesFormData;

  private requiredRules = requiredRules;

  private submit(): void {
    const isValid = (this.$refs.form as VForm).validate();

    if (isValid) {
      this.$emit('submit');
    }
  }

  private handleReset() {
    (this.$refs.form as HTMLFormElement).resetValidation();
    this.syncedData.countryCode = '';
    this.syncedData.postalCode = '';
    this.$emit('reset');
  }
}
